import React from "react";

import ProductPageTemplate from "../../components/global/layout/ProductPageTemplate";
import { sheets } from "../../constants/productPageData";

const SheetsPage = ({ location }) => {
    return (
        <ProductPageTemplate
            page={sheets}
            theme="green"
            location={location}
        />
    )
}

export default SheetsPage